var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSportsOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "M17 3v7.512l-.012.457c-.047 2.133-1.328 3.972-3.25 4.703h-.02l-.058.02-.66.257V20h1v1h1-5v-1h1v-4.05l-.66-.24-.078-.03h-.012c-1.922-.73-3.2-2.57-3.25-4.7V3zm1-1H6v3H4v6h2.012c.058 2.531 1.617 4.781 3.957 5.64.011 0 .02 0 .031.008V19H9v1H8v2h8v-2h-1v-1h-1v-2.352c.012 0 .02 0 .031-.007 2.328-.86 3.899-3.102 3.957-5.641H20V5h-2zm0 8V6h1v4zM5 10V6h1v4zm0 0"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsOutline);
export default __webpack_public_path__ + "static/media/sports_outline.970b3a60ab437c5bb98c18bbcd61f6f9.svg";
export { ForwardRef as ReactComponent };